export default __webpack_public_path__ + "static/media/adult-2021.f22bc82c.jpg";